import { createBrowserRouter } from 'react-router-dom';
import { routes } from '@/app/router';

/**
 * Browser-backed router instance used by the running app. Split from `router.tsx` so
 * `createBrowserRouter`'s real navigation side effects don't fire when tests import the routes.
 */
export const router = createBrowserRouter(routes);
